import * as React from 'react';

import { Amplify, I18n } from 'aws-amplify';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import { Footer, Header } from '~/components/organisms';

import Routes from '~/routes';
import { UserProvider } from '~/containers';
import UiProvider from '~/containers/UiProvider';
import { amplifyMessages } from '~/i18n';
import apolloClient from '~/apolloClient';
import awsConfig from '~/awsConfig';
import { sentryDsn } from '~/config';

Sentry.init({
  dsn: sentryDsn,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.1,
  release: process.env.VITE_REVISION,
});
Sentry.setTag('application', 'job-seeker-client');

Amplify.configure(awsConfig);
I18n.putVocabularies(amplifyMessages);
I18n.setLanguage('ja');

const App: React.FC = () => (
  <>
    <Toaster />
    <UserProvider>
      <ApolloProvider client={apolloClient}>
        <UiProvider>
          <BrowserRouter>
            <Header />
            <Routes />
            <Footer />
          </BrowserRouter>
        </UiProvider>
      </ApolloProvider>
    </UserProvider>
  </>
);

export default App;
